import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	error: {
		id: 'priority-picker.error',
		defaultMessage: "We couldn't find your priorities. Refresh and try again.",
		description: 'Message showed when priority picker couldnt be retrieved from the server .',
	},
	placeholder: {
		id: 'priority-picker.placeholder',
		defaultMessage: 'Select a value',
		description: 'Placeholder messsage for the priority picker.',
	},
});
